import React from "react";
import { useSelector } from "react-redux";

import { searchQuerySelector } from "redux/searchQuery";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { Box, IconButton, SxProps, Typography } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";

interface IProps {
  navigateToSearchPage: () => void;
}

export default function MobileLowPriceHeader(props: IProps) {
  const { navigateToSearchPage } = props;
  const { title } = useTranslations().translations.lowPriceCalendar;
  const searchQuery = useSelector(searchQuerySelector);

  return (
    <>
      <IconButton onClick={navigateToSearchPage}>
        <ChevronLeftOutlinedIcon sx={{ color: "white.main" }} />
      </IconButton>
      <Box sx={sxStyles.flightDetailsWrapper}>
        <Box sx={sxStyles.detailsWrapper}>
          <Box sx={sxStyles.detailsTop}>
            <Typography variant="h3">
              {`${searchQuery.flights[0].departure} - ${searchQuery.flights[0].arrival}`}
            </Typography>
          </Box>
          <Box sx={sxStyles.detailsBottom}>
            <Typography variant="titleSmall" sx={sxStyles.detailsBottomCaption}>
              {title}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={sxStyles.actionsWrapper}>
        <LanguageSelector color="white" />
      </Box>
    </>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  flightDetailsWrapper: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  actionsWrapper: {
    display: "flex",
  },
  detailsWrapper: {
    display: "flex",
    flexDirection: "column",
    "& h3": {
      lineHeight: 1,
      textTransform: "uppercase",
    },
  },
  detailsTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  detailsBottom: {
    display: "flex",
    lineHeight: "1",
  },
  detailsBottomCaption: {
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
    lineHeight: 1,
  },
};
